
export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Download & Install',
      description: 'Download IMPRIME VPN from our website and install it on your device in just a few clicks. The setup process is quick and straightforward.',
      icon: 'ri-download-cloud-line'
    },
    {
      number: '02',
      title: 'Choose Your Server',
      description: 'Select from our global network of high-speed servers. Pick the location that best suits your needs for optimal performance and access.',
      icon: 'ri-server-line'
    },
    {
      number: '03',
      title: 'Connect & Browse',
      description: 'Click the connect button and start browsing securely. Your connection is now encrypted and your identity is protected.',
      icon: 'ri-shield-check-line'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">How It Works</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">Get started with IMPRIME VPN in three simple steps</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="flex items-center justify-between mb-6">
                  <span className="text-6xl font-bold text-gray-200">{step.number}</span>
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-500 rounded-full flex items-center justify-center">
                    <i className={`${step.icon} text-white text-3xl`}></i>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-4xl text-blue-400"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
